import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Config } from '@cdn/config';
import { App } from './app';
import { Composition } from './composition';
import './styles/entry.css';

/**
 * Starts the application in the browser.
 */
export function mount(element: HTMLElement) {
	const composition = new Composition(Config.read(), {
		location: window.location,
		local: window.localStorage,
		tab: window.sessionStorage,
		languages: navigator.languages,
		dark: window.matchMedia?.('(prefers-color-scheme: dark)').matches,
		root: document.documentElement
	});
	createRoot(element).render(
		<StrictMode>
			<App composition={composition} />
		</StrictMode>
	);
}
